import {AgencyKit} from '../../domain/entities/AgencyKit.ts'

// Generation takes ~40 s; past this a PENDING kit is treated as failed (the
// Cloud Task was lost or ran out of retries) and offers "Retry".
export const KIT_STALLED_AFTER_MS = 3 * 60 * 1000

export type KitDisplayStatus = 'ACTIVE' | 'INACTIVE' | 'PENDING' | 'ERROR'

export const isKitStalled = (kit: AgencyKit) =>
    kit.status === 'PENDING' && Date.now() - (kit.updatedAt ?? kit.createdAt ?? Date.now()) > KIT_STALLED_AFTER_MS

export const kitDisplayStatus = (kit: AgencyKit): KitDisplayStatus => {
    if (kit.status === 'ERROR' || isKitStalled(kit)) return 'ERROR'
    if (kit.status === 'PENDING') return 'PENDING'
    return kit.isActive ? 'ACTIVE' : 'INACTIVE'
}
